// Project Types - Proje Tipleri
export const PROJECT_TYPES = {
  SINGLE_UNIT: 'SINGLE_UNIT',                     // Tek Bağımsız Bölüm
  MULTI_FLOOR_SINGLE_METER: 'MULTI_FLOOR_SINGLE_METER', // Çok Katlı Tek Sayaç (Dublex/Triblex)
  MULTI_METER: 'MULTI_METER',                     // Çok Sayaçlı Yapı
  HIGH_RISE: 'HIGH_RISE',                         // Yüksek Katlı Yapı
};

// Project Type Labels - Proje Tipi Etiketleri
export const PROJECT_TYPE_LABELS = {
  [PROJECT_TYPES.SINGLE_UNIT]: 'A - Tek Bağımsız Bölüm',
  [PROJECT_TYPES.MULTI_FLOOR_SINGLE_METER]: 'B - Çok Katlı Tek Sayaç',
  [PROJECT_TYPES.MULTI_METER]: 'C - Çok Sayaçlı Yapı',
  [PROJECT_TYPES.HIGH_RISE]: 'D - Yüksek Katlı Yapı',
};

// Document Types - Doküman Tipleri
export const DOCUMENT_TYPES = {
  // Ortak Dokümanlar
  VAZIYET_PLANI: 'vaziyet_plani',
  TOPRAKLAMA_PLANI: 'topraklama_plani',
  TOPRAKLAMA_DETAY: 'topraklama_detay',
  TOPRAKLAMA_HESAP: 'topraklama_hesap',
  NOTLAR: 'notlar',
  SEMBOLLER: 'semboller',
  BASLIK: 'baslik',

  // Değişken Dokümanlar
  YUKLEME_CETVELI: 'yukleme_cetveli',
  TEK_HAT_SEMASI: 'tek_hat_semasi',
  KOLON_SEMASI: 'kolon_semasi',
  PANO_DETAY: 'pano_detay',
  GERILIM_DUSUM: 'gerilim_dusum',
  ENERJI_ODASI: 'enerji_odasi',
  KABLO_BACASI: 'kablo_bacasi',
};

// Document Labels - Doküman Etiketleri
export const DOCUMENT_LABELS = {
  [DOCUMENT_TYPES.VAZIYET_PLANI]: 'Vaziyet Planı',
  [DOCUMENT_TYPES.TOPRAKLAMA_PLANI]: 'Topraklama Planı',
  [DOCUMENT_TYPES.TOPRAKLAMA_DETAY]: 'Topraklama Detayları',
  [DOCUMENT_TYPES.TOPRAKLAMA_HESAP]: 'Topraklama Hesabı',
  [DOCUMENT_TYPES.NOTLAR]: 'Notlar',
  [DOCUMENT_TYPES.SEMBOLLER]: 'Semboller',
  [DOCUMENT_TYPES.BASLIK]: 'Başlık',
  [DOCUMENT_TYPES.YUKLEME_CETVELI]: 'Yükleme Cetveli',
  [DOCUMENT_TYPES.TEK_HAT_SEMASI]: 'Tek Hat Şeması',
  [DOCUMENT_TYPES.KOLON_SEMASI]: 'Kolon Şeması',
  [DOCUMENT_TYPES.PANO_DETAY]: 'Pano Detayı',
  [DOCUMENT_TYPES.GERILIM_DUSUM]: 'Gerilim Düşümü Hesabı',
  [DOCUMENT_TYPES.ENERJI_ODASI]: 'Enerji Odası',
  [DOCUMENT_TYPES.KABLO_BACASI]: 'Kablo Bacası',
};

// Common Documents - Tüm projelerde ortak olan dokümanlar
export const COMMON_DOCUMENTS = [
  DOCUMENT_TYPES.VAZIYET_PLANI,
  DOCUMENT_TYPES.TOPRAKLAMA_PLANI,
  DOCUMENT_TYPES.TOPRAKLAMA_DETAY,
  DOCUMENT_TYPES.TOPRAKLAMA_HESAP,
  DOCUMENT_TYPES.NOTLAR,
  DOCUMENT_TYPES.SEMBOLLER,
  DOCUMENT_TYPES.BASLIK,
];

// All Documents - Tüm dokümanlar listesi (sıralı)
export const ALL_DOCUMENTS = [
  // Ortak dokümanlar
  DOCUMENT_TYPES.VAZIYET_PLANI,
  DOCUMENT_TYPES.TOPRAKLAMA_PLANI,
  DOCUMENT_TYPES.TOPRAKLAMA_DETAY,
  DOCUMENT_TYPES.TOPRAKLAMA_HESAP,
  // Değişken dokümanlar
  DOCUMENT_TYPES.YUKLEME_CETVELI,
  DOCUMENT_TYPES.TEK_HAT_SEMASI,
  DOCUMENT_TYPES.KOLON_SEMASI,
  DOCUMENT_TYPES.PANO_DETAY,
  DOCUMENT_TYPES.GERILIM_DUSUM,
  DOCUMENT_TYPES.ENERJI_ODASI,
  DOCUMENT_TYPES.KABLO_BACASI,
  // Sabit dokümanlar (sonda)
  DOCUMENT_TYPES.NOTLAR,
  DOCUMENT_TYPES.SEMBOLLER,
  DOCUMENT_TYPES.BASLIK,
];

// Project Type Document Map - Proje tipine göre seçili dokümanlar
export const PROJECT_TYPE_DOCUMENTS = {
  [PROJECT_TYPES.SINGLE_UNIT]: [
    ...COMMON_DOCUMENTS,
    DOCUMENT_TYPES.YUKLEME_CETVELI,
    DOCUMENT_TYPES.TEK_HAT_SEMASI,
    DOCUMENT_TYPES.PANO_DETAY,
    DOCUMENT_TYPES.GERILIM_DUSUM,
  ],
  [PROJECT_TYPES.MULTI_FLOOR_SINGLE_METER]: [
    ...COMMON_DOCUMENTS,
    DOCUMENT_TYPES.YUKLEME_CETVELI,
    DOCUMENT_TYPES.KOLON_SEMASI,
    DOCUMENT_TYPES.PANO_DETAY,
    DOCUMENT_TYPES.GERILIM_DUSUM,
  ],
  [PROJECT_TYPES.MULTI_METER]: [
    ...COMMON_DOCUMENTS,
    DOCUMENT_TYPES.YUKLEME_CETVELI,
    DOCUMENT_TYPES.KOLON_SEMASI,
    DOCUMENT_TYPES.TEK_HAT_SEMASI,
    DOCUMENT_TYPES.PANO_DETAY,
    DOCUMENT_TYPES.GERILIM_DUSUM,
  ],
  [PROJECT_TYPES.HIGH_RISE]: [
    ...COMMON_DOCUMENTS,
    DOCUMENT_TYPES.YUKLEME_CETVELI,
    DOCUMENT_TYPES.KOLON_SEMASI,
    DOCUMENT_TYPES.TEK_HAT_SEMASI,
    DOCUMENT_TYPES.PANO_DETAY,
    DOCUMENT_TYPES.GERILIM_DUSUM,
    DOCUMENT_TYPES.ENERJI_ODASI,
    DOCUMENT_TYPES.KABLO_BACASI,
  ],
};

// Document Categories - Doküman kategorileri (UI için)
export const DOCUMENT_CATEGORIES = {
  COMMON: {
    label: 'Ortak Dokümanlar',
    documents: COMMON_DOCUMENTS,
  },
  ELECTRICAL: {
    label: 'Elektrik Dokümanları',
    documents: [
      DOCUMENT_TYPES.YUKLEME_CETVELI,
      DOCUMENT_TYPES.TEK_HAT_SEMASI,
      DOCUMENT_TYPES.KOLON_SEMASI,
      DOCUMENT_TYPES.PANO_DETAY,
      DOCUMENT_TYPES.GERILIM_DUSUM,
    ],
  },
  SPECIAL: {
    label: 'Özel Dokümanlar',
    documents: [
      DOCUMENT_TYPES.ENERJI_ODASI,
      DOCUMENT_TYPES.KABLO_BACASI,
    ],
  },
};

// High Rise Threshold - Yüksek katlı yapı eşiği
export const HIGH_RISE_FLOOR_THRESHOLD = 10;

// ── Doküman yerleşim grupları (layout) ──────────────────────────────
// Her doc bir gruba ait; layout grup-grup soldan sağa yerleştirir.
// Sabit (pinned) olarak işaretli docs gruplar dışında, sağ şeride alt-alta dizilir.
//
// İsim eşleşmesi useElectricalLayout'taki INITIAL_DEFS isimleriyle aynı olmalı
// (Türkçe karakterli isimler dahil).
export const LAYOUT_GROUP = {
  PLAN_VAZIYET: 'plan_vaziyet',     // Grup 1
  TOPRAKLAMA:   'topraklama',       // Grup 2
  PLAN_KAT:     'plan_kat',         // Grup 3
  HESAPLAR:     'hesaplar',         // Grup 4
};

export const LAYOUT_GROUP_ORDER = [
  LAYOUT_GROUP.PLAN_VAZIYET,
  LAYOUT_GROUP.TOPRAKLAMA,
  LAYOUT_GROUP.PLAN_KAT,
  LAYOUT_GROUP.HESAPLAR,
];

export const DOC_NAME_TO_GROUP = {
  'Vaziyet Planı':         LAYOUT_GROUP.PLAN_VAZIYET,
  // Topraklama grubu (Ground Floor = topraklama kat planı olarak oluşturuluyor)
  'Topraklama Planı':      LAYOUT_GROUP.TOPRAKLAMA,
  'Ground Floor':          LAYOUT_GROUP.TOPRAKLAMA,
  'Topraklama Detayları':  LAYOUT_GROUP.TOPRAKLAMA,
  'Topraklama Hesabı':     LAYOUT_GROUP.TOPRAKLAMA,
  // Kat planları
  'Kat Planı':             LAYOUT_GROUP.PLAN_KAT,
  // Hesaplar + diğer içerikler
  'Yükleme Cetveli':       LAYOUT_GROUP.HESAPLAR,
  'Gerilim Düşümü':        LAYOUT_GROUP.HESAPLAR,
  'TekHat  Şeması':        LAYOUT_GROUP.HESAPLAR,
  'Kolon Şeması':          LAYOUT_GROUP.HESAPLAR,
  'Pano Detay':            LAYOUT_GROUP.HESAPLAR,
  'Enerji Odasi':          LAYOUT_GROUP.HESAPLAR,
  'Kablo Bacası':          LAYOUT_GROUP.HESAPLAR,
};

// Sabit (sağ şeride) varsayılan olarak gidecek dokümanlar.
// Kullanıcı veya proje bu seti override edebilir.
export const DEFAULT_PINNED_DOCS = ['Baslik', 'Notlar', 'Sembol Listesi'];

// Gruplara dahil olmayan ama layout'a girebilecek docs için fallback grup
export const FALLBACK_LAYOUT_GROUP = LAYOUT_GROUP.HESAPLAR;

// ── Layout ayarları (proje çerçevesi, dizilim, boşluk, hizalama) ───────
// Türk inceleme/ozalit yükseklik standartları (×5 multiplier = scene units)
export const STANDARD_PAPER_HEIGHTS = [310, 457, 620, 760, 860, 914, 1070];
export const PAPER_HEIGHT_MULTIPLIER = 5;

export const PAPER_SIZE_OPTIONS = [
  { value: 'auto', label: 'Otomatik (içeriğe göre)' },
  ...STANDARD_PAPER_HEIGHTS.map(h => ({
    value: String(h),
    label: `${h} (${h * PAPER_HEIGHT_MULTIPLIER} birim)`,
  })),
];

export const LAYOUT_DIRECTION_OPTIONS = [
  { value: 'ltr', label: 'Soldan → Sağa' },
  { value: 'rtl', label: 'Sağdan → Sola' },
];

export const VERTICAL_ALIGN_OPTIONS = [
  { value: 'top',    label: 'Üst' },
  { value: 'center', label: 'Orta' },
  { value: 'bottom', label: 'Alt' },
];

export const DEFAULT_LAYOUT_SETTINGS = {
  paperSize: 'auto',       // 'auto' | '310' | '457' | ...
  direction: 'ltr',        // 'ltr' | 'rtl'
  docSpacing: 50,          // DOCUMENT_OFFSET; sütun-içi + gruplar-arası kullanılır
  verticalAlign: 'bottom', // 'top' | 'center' | 'bottom'
};

// Helper function to detect project type automatically
export const detectProjectType = ({ floorCount, meterCount, panelCount, hasEnergyRoom }) => {
  // Yüksek katlı yapı kontrolü
  if (floorCount >= HIGH_RISE_FLOOR_THRESHOLD || hasEnergyRoom) {
    return PROJECT_TYPES.HIGH_RISE;
  }

  // Çok sayaçlı yapı kontrolü
  if (meterCount > 1) {
    return PROJECT_TYPES.MULTI_METER;
  }

  // Çok katlı tek sayaç (dublex/triblex) kontrolü
  if (floorCount > 1 && panelCount > 1) {
    return PROJECT_TYPES.MULTI_FLOOR_SINGLE_METER;
  }

  // Varsayılan: Tek bağımsız bölüm
  return PROJECT_TYPES.SINGLE_UNIT;
};

// Get default documents for project type
export const getDefaultDocuments = (projectType) => {
  return PROJECT_TYPE_DOCUMENTS[projectType] || PROJECT_TYPE_DOCUMENTS[PROJECT_TYPES.SINGLE_UNIT];
};
